import { render, staticRenderFns } from "./ParcelTypes.vue?vue&type=template&id=c95417fe&"
import script from "./ParcelTypes.vue?vue&type=script&lang=js&"
export * from "./ParcelTypes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports